import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { BiEditAlt } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
// import { GrDocumentDownload } from "react-icons/gr";


function Readbaxira() {

    const [filterSearch, setFilterSearch] = useState("")
    const [filtertemp, setFiltertemp] = useState("")
    const [customer, SetCustomer] = useState([])
    const [ID, setID] = useState("")

    const [carPick, setCarPick] = useState("");

    const [daf3date, setdaf3date] = useState("");

    const [baxiranum, setbaxiranum] = useState("");

    const [driver, setdriver] = useState("");
    const [baxiraname, setbaxiraname] = useState("");
    const [vinnum, setvinnum] = useState("");
    const [coc, setcoc] = useState("");

    const [datepick, setdatepick] = useState("");
    // const [pays, setpays] = useState([1]);
    // const [RAND, setRAND] = useState("");
    const [newmoney, setnewmoney] = useState("");

    const [trans, settrans] = useState([]);
    const [paydate, setpaydate] = useState("");
    const [tebini, settebini] = useState("");



    const updateQabz = (id) => {
        if (carPick === "") {
            customer.filter(e => e.ID === ID).map(e => (setCarPick(e.carsqty)))
        }
        if (baxiraname === "") {
            customer.filter(e => e.ID === ID).map(e => (setbaxiraname(e.boatname)))
        }
        if (baxiranum === "") {
            customer.filter(e => e.ID === ID).map(e => (setbaxiranum(e.boatnum)))
        }
        if (vinnum === "") {
            customer.filter(e => e.ID === ID).map(e => (setvinnum(e.vinnum)))
        }
        if (driver === "") {
            customer.filter(e => e.ID === ID).map(e => (setdriver(e.techw)))
        }
        if (daf3date === "") {
            customer.filter(e => e.ID === ID).map(e => (setdaf3date(e.datedaf3)))
        }
        if (datepick === "") {
            customer.filter(e => e.ID === ID).map(e => (setdatepick(e.datePick)))
        }
        if (coc === "") {
            customer.filter(e => e.ID === ID).map(e => (setcoc(e.tebini)))
        }

    }
    const updateQuery = () => {
        axios.put("https://car-api.redcode.app/baxira/updatebaxira/", {
            carPick: carPick,
            daf3date: daf3date,
            baxiranum: baxiranum,
            driver: driver,
            baxiraname: baxiraname,
            vinnum: vinnum,
            coc: coc,
            datepick: datepick,
            ID: ID
        })
            .then((res) => {
                window.location.reload(false)
            })
    }


    useEffect(() => {
        axios.get("https://car-api.redcode.app/trans/getbaxira/").then((response) => {
            settrans(response.data)
            // setCustomid(props.asman)
        });
    }, []);




    useEffect(() => {
        axios.get("https://car-api.redcode.app/baxira/allbaxira/").then((response) => {
            SetCustomer(response.data)
        })

    }, [])


    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'start', padding: "20px" }}>
                <div className="col-md-12 col-lg-12" dir="rtl">
                    <div style={{ display: "flex", flexDirection: "row" }}>
                        <h4 className="mb-1">باخرە</h4>
                        <div className="col-md-2 pe-4">

                            <label htmlFor="cc-number" className="form-label "> گەڕان بەدوای ناوی باخیرە</label>
                            <input type="text" className="form-control" onChange={e => setFilterSearch(e.target.value)} id="cc-number" placeholder="" />
                        </div>
                        <div className="col-md-2 pe-4">

                            <label htmlFor="cc-number" className="form-label"> گەڕان بەدوای مەنەفێست باخیرە</label>
                            <input type="text" className="form-control" onChange={e => setFiltertemp(e.target.value)} id="cc-number" placeholder="" />
                        </div>
                    </div>
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col">#</th>

                                <th scope="col">ژمارەی سەیارەکان</th>
                                <th scope="col">ناوی باخیرە</th>
                                <th scope="col">ژمارە باخرە</th>
                                <th scope="col">مەنەفێست باخیرە</th>
                                <th scope="col">کۆی گشتی</th>

                                {/* <th scope="col">کاتی دفع</th> */}
                                <th scope="col">تێچو</th>

                                <th scope="col">کاتی بارکردن</th>
                                <th scope="col"> تێبینی</th>
                                {/* <th scope="col">پارە بدە</th> */}

                            </tr>
                        </thead>
                        <tbody>
                            {customer.filter((e => {
                                if (filterSearch === "" && filtertemp === "") {
                                    return e
                                } if (e.boatname.includes(filterSearch) && filtertemp === "") {
                                    return e
                                } if (e.vinnum.includes(filtertemp) && filterSearch === "") {
                                    return e
                                } if (e.vinnum.includes(filtertemp) && e.boatname.includes(filterSearch)) {
                                    return e
                                }
                            })).map(e => {
                                return <tr
                                // className={
                                // e.daf3 === e.totalall ? "table-success" : e.madfw3 > 0 ? "table-warning" : "table-danger"
                                // }
                                >
                                    <th scope="row">{e.ID}</th>

                                    <td >{e.carsqty}</td>
                                    <td>{e.boatname}</td>
                                    <td>{e.boatnum}</td>
                                    <td>{e.vinnum}</td>
                                    <td>{e.totalall}</td>

                                    {/* <td>{e.daf3date}</td> */}
                                    <td>{e.techw}</td>

                                    <td>{e.datePick}</td>
                                    <td>{e.tebini}</td>
                                    {/* <td className="notPrint">
                                        {e.daf3 === e.totalall ? null :
                                            <button type="button" className="btn btn-primary btn-sm p-1" data-bs-toggle="modal" data-bs-target="#staticBackdroppay"
                                                onClick={() =>
                                                    axios.get(`https://car-api.redcode.app/baxira/pay/${e.RAND}/`).then((response) => {
                                                        setpays(response.data)
                                                    })
                                                }>پارە بدە</button>
                                        }
                                    </td> */}

                                    <td className="notPrint">

                                        <button type="button" className="btn btn-warning btn-sm p-1" data-bs-toggle="modal" data-bs-target="#staticBackdroppp" onClick={() => setID(e.ID)}><BiEditAlt /></button>
                                        <button type="button" className="btn btn-danger btn-sm p-1" data-bs-toggle="modal" data-bs-target="#exampleModalll" onClick={() => setID(e.ID)}><AiFillDelete /></button>



                                        <div className="modal fade" id="exampleModalll" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                            <div className="modal-dialog modal-dialog-centered">
                                                <div className="modal-content">
                                                    <div className="modal-header">
                                                        <h5 className="modal-title" id="exampleModalLabel">قبظ دەسڕیتەوە؟</h5>

                                                    </div>
                                                    <div className="modal-body">
                                                        <h5>
                                                            قبظ ژمارە ( {ID} ) دەسڕێتەوە
                                                        </h5>
                                                    </div>
                                                    <div className="modal-footer">
                                                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">گەڕانەوە</button>
                                                        <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={() => axios.delete(`https://car-api.redcode.app/baxira/deletebaxira/${ID}/`).then((res) => {
                                                            window.location.reload(false)
                                                        })}
                                                        >سڕینەوە</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </td>
                                    {/* <td className="notPrint" style={{ textAlign: "center" }}> <button type="button" className="btn btn-success btn-sm p-1" data-bs-toggle="modal" data-bs-target="#staticBackdrop" onClick={() => setID(e.ID)} ><GrDocumentDownload /></button>

                                    </td> */}
                                </tr>
                            })}




                            <div className="modal fade print-container" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                                <div className="modal-dialog modal-fullscreen">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="staticBackdropLabel" style={{ color: "black" }}>ژ / {ID}</h5>
                                            {/* <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> */}
                                        </div>
                                        <div className="modal-body" style={{ color: "black" }}>
                                            <div className="modal-body" >
                                                {customer.filter(e => e.ID === ID).map(e =>
                                                (
                                                    <div key={e.ID}>
                                                        <div style={{ paddingTop: "20px", textAlign: "center" }}>
                                                            <h5 className="modal-title" id="staticBackdropLabel" style={{ color: "black" }}>ڕێکەوت / {e.datePick}</h5>

                                                        </div>
                                                        <div style={{ marginRight: "150px", paddingTop: "50px", paddingBottom: "50px" }}>
                                                            <div>
                                                                <div className="form-group">
                                                                    <label htmlFor="exampleInputEmail1">ناوی لایەنی یەکەم : {e.payer}</label>
                                                                    {/* <input type="text" className="form-control" aria-describedby="emailHelp" onChange={e => setNewname(e.target.value)} placeholder={e.name} /> */}
                                                                    {/* <small id="emailHelp" className="form-text text-muted">We'll never share your email with anyone else.</small> */}
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="exampleInputEmail1">About: {e.about}</label>
                                                                    {/* <input type="text" className="form-control" aria-describedby="emailHelp" onChange={e => setNewcompany(e.target.value)} placeholder={e.company} /> */}
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <div className="form-group">
                                                                    <label htmlFor="exampleInputEmail1">نقل : {e.naql}</label>
                                                                    <label htmlFor="exampleInputEmail1">{e.name}</label>
                                                                    {/* <input type="text" className="form-control" aria-describedby="emailHelp" onChange={e => setNewemail(e.target.value)} placeholder={e.email} /> */}
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="exampleInputEmail1">گومرگ : {e.gumrg}</label>
                                                                    <label htmlFor="exampleInputEmail1">{e.phonenum}</label>
                                                                    {/* <input type="text" className="form-control" aria-describedby="emailHelp" onChange={e => setNewphonenum(e.target.value)} placeholder={e.phonenum} /> */}
                                                                </div>
                                                            </div>

                                                        </div>


                                                        <div style={{ display: 'flex', justifyContent: "space-evenly" }}>

                                                            <div className="form-group">
                                                                <label htmlFor="exampleInputEmail1"> ئیمزای وەرگر</label>

                                                                {/* <input type="text" className="form-control" aria-describedby="emailHelp" onChange={e => setNewname(e.target.value)} placeholder={e.name} /> */}
                                                                {/* <small id="emailHelp" className="form-text text-muted">We'll never share your email with anyone else.</small> */}


                                                            </div>

                                                            <div className="form-group">

                                                                <label htmlFor="exampleInputEmail1">ئیمزای ژمێریار</label>
                                                                <div className="form-group">
                                                                    <label htmlFor="exampleInputEmail1">{e.m7asb}</label>

                                                                    {/* <input type="text" className="form-control" aria-describedby="emailHelp" onChange={e => setNewcompany(e.target.value)} placeholder={e.company} /> */}
                                                                </div>
                                                                {/* <input type="text" className="form-control" aria-describedby="emailHelp" onChange={e => setNewemail(e.target.value)} placeholder={e.email} /> */}
                                                            </div>



                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="modal-footer notPrint">
                                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Dismiss</button>
                                            <button type="button" className="btn btn-primary" onClick={() => window.print()}>Print</button>

                                        </div>
                                    </div>
                                </div>
                            </div>






                            <div className="modal fade" id="staticBackdroppp" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="staticBackdropLabel" style={{ color: "black" }}>باخیرە تازە کردنەوە</h5>

                                        </div>
                                        <div className="modal-body" style={{ color: "black" }}>
                                            <div className="modal-body">
                                                {customer.filter(e => e.ID === ID).map(e =>
                                                (
                                                    <div key={e.ID}>
                                                        <form>


                                                            <div className="form-group">
                                                                <label htmlFor="exampleInputEmail1">ژمارەی سەیارەکان</label>
                                                                <input type="number" className="form-control" aria-describedby="emailHelp" placeholder={e.carsqty} onChange={e => setCarPick(e.target.value)} />
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="exampleInputEmail1">ناوی باخیرە</label>
                                                                <input type="number" className="form-control" aria-describedby="emailHelp" placeholder={e.boatname} onChange={e => setbaxiraname(e.target.value)} />
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="exampleInputEmail1">ژمارەی باخیرە</label>
                                                                <input type="number" className="form-control" aria-describedby="emailHelp" placeholder={e.boatnum} onChange={e => setbaxiranum(e.target.value)} />
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="exampleInputEmail1">مەنەفێست باخیرە</label>
                                                                <input type="number" className="form-control" aria-describedby="emailHelp" placeholder={e.vinnum} onChange={e => vinnum(e.target.value)} />
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="exampleInputEmail1">تێچو</label>
                                                                <input type="number" className="form-control" aria-describedby="emailHelp" placeholder={e.techw} onChange={e => setdriver(e.target.value)} />
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="exampleInputEmail1">کاتی بارکردن</label>
                                                                <input type="date" className="form-control" aria-describedby="emailHelp" placeholder={e.datePick} onChange={e => setdatepick(e.target.value)} />
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="exampleInputEmail1">کاتی دفع</label>
                                                                <input type="date" className="form-control" aria-describedby="emailHelp" placeholder={e.datedaf3} onChange={e => setdaf3date(e.target.value)} />
                                                            </div>



                                                            <div className="form-group">
                                                                <label htmlFor="exampleInputEmail1"> تێبینی</label>
                                                                <input type="number" className="form-control" aria-describedby="emailHelp" placeholder={e.tebini} onChange={e => setcoc(e.target.value)} />
                                                            </div>


                                                        </form>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">گەڕانەوە</button>
                                            <button type="button" data-bs-toggle="modal" data-bs-target="#staticBackdrop2" className="btn btn-primary" onClick={updateQabz} >تازە کردنەوە</button>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal fade" id="staticBackdrop2" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 style={{ color: "black" }} className="modal-title" id="staticBackdropLabel">دڵنیایت؟</h5>

                                        </div>
                                        <div className="modal-body">
                                            {customer.filter(e => e.ID === ID).map(e =>
                                            (
                                                <div key={e.ID}>
                                                    <form style={{ color: "black" }}>
                                                        <div className='yousure'>
                                                            <div>
                                                                <div className="form-group">
                                                                    <label htmlFor="exampleInputEmail1">ژمارەی سەیارەکان</label>
                                                                    <h2>{carPick}</h2>
                                                                </div>

                                                                <div className="form-group">
                                                                    <label htmlFor="exampleInputEmail1">
                                                                        ناوی باخیرە</label>
                                                                    <h2>{baxiraname}</h2>                                                        </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="exampleInputEmail1">ژمارەی باخیرە</label>
                                                                    <h2>{baxiranum}</h2>                                                        </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="exampleInputEmail1">
                                                                        مەنەفێست باخیرە</label>
                                                                    <h2>{vinnum}</h2>                                                        </div>

                                                            </div>
                                                            <div>

                                                                <div className="form-group">
                                                                    <label htmlFor="exampleInputEmail1"> کاتی دفع</label>
                                                                    <h2>{daf3date}</h2>                                                        </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="exampleInputEmail1"> کاتی بارکردن</label>
                                                                    <h2>{datepick}</h2>                                                        </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="exampleInputEmail1"> تێچو</label>
                                                                    <h2>{driver}</h2>                                                        </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="exampleInputEmail1">تێبینی</label>
                                                                    <h2>{coc}</h2>                                                        </div>

                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">گەڕانەوە</button>
                                            <button type="button" className="btn btn-primary" onClick={updateQuery} >تازە کردنەوە</button>
                                        </div>
                                    </div>
                                </div>
                            </div>





                            {/* <div className="modal fade" id="staticBackdroppay" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="staticBackdropLabel" style={{ color: "black" }}>پارە بدە</h5>

                                        </div>
                                        <div className="modal-body" style={{ color: "black" }}>
                                            <div className="modal-body">
                                                <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                                  
                                                    <label htmlFor="exampleInputEmail1">پارەی ماوە : {
                                                        pays !== [1] ? pays[0].baqi : null
                                                    }</label>
                                                    <label htmlFor="exampleInputEmail1">پارەی مدفوع : {
                                                        pays !== [1] ? pays[0].daf3 : null
                                                    }</label>
                                                </div>
                                                <hr className="my-4" />

                                                <div >
                                                    <form>


                                                       

                                                        <div className="form-group">
                                                            <label htmlFor="exampleInputEmail1"> پارە بدە</label>
                                                            <div className='pb-3' style={{ display: "flex" }}>
                                                                <input style={{ width: "80%" }} type="number" max={pays !== [1] ? pays[0].baqi : null} onClick={() => setRAND(pays !== [1] ? pays[0].RAND : null)} className="form-control" aria-describedby="emailHelp" onChange={e => setnewmoney(e.target.value)} />
                                                                <button style={{ width: "20%" }} type="button" className="btn btn-dark"
                                                                    onClick={() => {
                                                                        axios.post("https://car-api.redcode.app/baxira/createbaxira/", {
                                                                            carPick: pays !== [1] ? pays[0].carPick : null,
                                                                            daf3date: pays !== [1] ? pays[0].daf3date : null,
                                                                            techw: pays !== [1] ? pays[0].techw : null,
                                                                            baxiranum: pays !== [1] ? pays[0].baxiranum : null,
                                                                            boatname: pays !== [1] ? pays[0].boatname : null,
                                                                            boatnum: pays !== [1] ? pays[0].boatnum : null,
                                                                            datepick: pays !== [1] ? pays[0].datepick : null,
                                                                            total: pays !== [1] ? pays[0].total : null,
                                                                            daf3: (newmoney !== "" ? JSON.parse(newmoney) : null) + (pays !== [1] ? pays[0].daf3 : null),
                                                                            baqi: (pays !== [1] ? pays[0].baqi : null) - (newmoney),
                                                                            RAND: RAND,




                                                                        }).then((res) => {
                                                                            window.location.reload(false)

                                                                        })
                                                                    }}


                                                                >پارە بدە</button>
                                                            </div>
                                                        </div>


                                                        <h5>پارەی باقی تازە  :  {(newmoney !== "" ? JSON.parse(newmoney) : null) + (pays !== [1] ? pays[0].daf3 : null)}</h5>
                                                        <h5>پارەی ماوە تازە  :  {(pays !== [1] ? pays[0].baqi : null) - (newmoney)}</h5>

                                                        <div>
                                                            <hr className="my-4" />

                                                            < div style={{}}>
                                                                <div className="col-md-12 col-lg-12" dir="rtl">
                                                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                                        <h4 className="mb-1">پارەدانی پێشوو</h4>

                                                                    </div>

                                                                    <table className="table table-striped print-container">
                                                                        <thead>
                                                                            <tr>
                                                                                <th scope="col">#</th>
                                                                                <th scope="col">کۆی گشتی </th>
                                                                                <th scope="col">مدفوع</th>
                                                                                <th scope="col">ماوە</th>

                                                                                <th scope="col">کات</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {pays.slice(0).reverse().map(e => {
                                                                                return <tr key={e.ID}>
                                                                                    <th scope="row"></th>
                                                                                    <td>{e.totalall}</td>
                                                                                    <td>{e.daf3}</td>
                                                                                    <td>{e.baqi}</td>

                                                                                    <td>{e.dateSql}</td>

                                                                                </tr>
                                                                            })}

                                                                        </tbody>

                                                                    </table>






                                                                </div>
                                                            </div >
                                                        </div>

                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">گەڕانەوە</button>


                                        </div>
                                    </div>
                                </div>
                            </div>
 */}




                        </tbody>
                    </table>


                    <div className="col-md-10 col-lg-10 bg-dark text-white p-2" style={{ position: "sticky", bottom: "0", display: "flex", justifyContent: "space-evenly" }}>
                        {/* bg-dark text-white */}
                        <div className="row">

                            <h6 className="">کۆی ژمارەی سەیارە</h6>
                            {/* <small className="text-muted">١ دۆلار بەرامبەر دینار</small> */}

                            <span className="">{customer.reduce((a, v) => a = a + v.carsqty, 0)}</span>
                            {/* <span className="">{localStorage.getItem("webinter") === "1" ? localStorage.getItem("dinar") : "daxl bka"}</span> */}
                        </div>

                        <div className="row">

                            <h6 className="">کۆی گشتی تێچوو</h6>
                            {/* <small className="text-muted"> ڕۆژ و کات</small> */}

                            <span className="">${customer.reduce((a, v) => a = a + v.techw, 0)}</span>
                        </div>

                        <div className="row">

                            <h6 className="">کۆی گشتی دفع</h6>
                            {/* <small className="text-muted"></small> */}

                            <span className="">$ {trans.reduce((a, v) => a = a + v.amount, 0)}</span>
                        </div>
                        <div className="row">

                            <h6 className="">کۆی گشتی ماوە</h6>
                            {/* <small className="text-muted"></small> */}

                            <span className="">$ {customer.reduce((a, v) => a = a + v.techw, 0) - trans.reduce((a, v) => a = a + v.amount, 0)}</span>
                        </div>

                        <button type="button" className="btn btn-primary  p-1" data-bs-toggle="modal" data-bs-target="#staticBackdroppayall"


                        >پارە بدە</button>
                    </div>



                    <div className="modal fade" id="staticBackdroppayall" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="staticBackdropLabel" style={{ color: "black" }}>پارە بدە</h5>

                                </div>
                                <div className="modal-body" style={{ color: "black" }}>
                                    <div className="modal-body">
                                        <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>

                                            <label style={{ fontWeight: "700", fontSize: "16px" }} htmlFor="exampleInputEmail1">کۆی گشتی ماوە :
                                                $ {customer.reduce((a, v) => a = a + v.techw, 0) - trans.reduce((a, v) => a = a + v.amount, 0)}
                                            </label>
                                            <label style={{ fontWeight: "700", fontSize: "16px" }} htmlFor="exampleInputEmail1">کۆی گشتی مدفوع :
                                                $ {trans.reduce((a, v) => a = a + v.amount, 0)}
                                            </label>
                                        </div>
                                        <hr className="my-4" />

                                        <div >
                                            <form>

                                                <div className="form-group" style={{ display: "flex", flexDirection: "row" }}>

                                                    <div className='pb-3' style={{ flex: "2", display: "flex", flexDirection: "column" }}>
                                                        <label style={{ fontWeight: "700", fontSize: "16px" }} htmlFor="exampleInputEmail1"> بڕی پارە</label>

                                                        <input style={{ width: "80%" }} type="number"
                                                            className="form-control" aria-describedby="emailHelp" onChange={e => setnewmoney(e.target.value)} />
                                                        <label style={{ fontWeight: "700", fontSize: "16px" }} htmlFor="exampleInputEmail1"> کات</label>

                                                        <input style={{ width: "80%" }} type="date"
                                                            className="form-control" aria-describedby="emailHelp" onChange={e => setpaydate(e.target.value)} />

                                                        <label style={{ fontWeight: "700", fontSize: "16px" }} htmlFor="exampleInputEmail1"> تێبینی</label>

                                                        <textarea style={{ width: "80%" }}
                                                            className="form-control" aria-describedby="emailHelp" onChange={e => settebini(e.target.value)} />


                                                    </div>
                                                    <button style={{ width: "20%" }} type="button" className="btn btn-dark"
                                                        onClick={() => {
                                                            axios.post("https://car-api.redcode.app/trans/gwmrg/", {
                                                                transtype: 4,
                                                                amount: newmoney,
                                                                RANDID: 4,
                                                                datePick: paydate,
                                                                tebini: tebini

                                                            }).then((res) => {
                                                                window.location.reload(false)
                                                            })
                                                        }}

                                                    >پارە بدە</button>
                                                </div>


                                                <h5>پارەی باقی تازە  :  {(newmoney !== "" ? JSON.parse(newmoney) : null) + trans.reduce((a, v) => a = a + v.amount, 0)}</h5>
                                                <h5>پارەی ماوە تازە  :  {customer.reduce((a, v) => a = a + v.techw, 0) - trans.reduce((a, v) => a = a + v.amount, 0) - (newmoney)}</h5>

                                                <div>
                                                    <hr className="my-4" />

                                                    < div style={{}}>
                                                        <div className="col-md-12 col-lg-12" dir="rtl">
                                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                                <h4 className="mb-1">پارەدانی پێشوو</h4>

                                                            </div>

                                                            <table className="table table-striped print-container">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col">#</th>

                                                                        <th scope="col">کۆی گشتی دۆلار</th>

                                                                        <th scope="col">کات</th>
                                                                        <th scope="col">تێبینی</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {trans.map(e => {
                                                                        return <tr key={e.id}>
                                                                            <th scope="row"></th>
                                                                            <td>{e.amount} $</td>


                                                                            <td>{e.datePick}</td>
                                                                            <td>{e.tebini}</td>
                                                                            <td className="notPrint"><button type="button" className="btn btn-danger btn-sm p-1 " data-bs-target="#exampleModalToggle3" data-bs-toggle="modal" onClick={() => setID(e.id)}><AiFillDelete /></button>


                                                                            </td>
                                                                        </tr>
                                                                    })}

                                                                </tbody>

                                                            </table>


                                                        </div>
                                                    </div >
                                                </div>

                                            </form>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">گەڕانەوە</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal fade" id="exampleModalToggle3" tabindex="-1" aria-labelledby="exampleModalToggleLabel23" aria-hidden="true">
                        <div className="modal-dialog modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalToggleLabel23">بڕی پارەدان دەسڕیتەوە؟</h5>

                                </div>
                                <div className="modal-body">
                                    <h5>

                                        بڕی پارەدان  دەسڕێتەوە
                                    </h5>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">گەڕانەوە</button>
                                    <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={() => axios.delete(`https://car-api.redcode.app/trans/deletetrans/${ID}`).then((res) => {
                                        window.location.reload(false)
                                    })}
                                    >سڕینەوە</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Readbaxira
